module.exports = __webpack_public_path__ + "img/arrow-top.bcd0bf9d.svg";